import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './overlay-spinning.component.html',
  styleUrls: ['./overlay-spinning.component.scss']
})
export class OverlaySpinningComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
